import http from './http';

const AGREED_HOUR_PATH = '/agreed_hour';

const agreedHoursSvcClient = {
  create(data) {
    return http
      .post(`${AGREED_HOUR_PATH}`, data)
      .then(({ data }) => data)
      .catch(e => {
        if (e?.response?.data?.error?.message) {
          throw new Error(e.response.data.error.message);
        }
      });
  },
  get(businessId, employeeId) {
    return http
      .get(
        `${AGREED_HOUR_PATH}/installation/${businessId}/employee/${employeeId}`
      )
      .then(({ data }) => data)
      .catch(e => {
        if (e?.response?.data?.error?.message) {
          throw new Error(e.response.data.error.message);
        }
        return Promise.reject(e);
      });
  },
};

export default agreedHoursSvcClient;
